import axios from './axios';

const API_URL = '/C4-Nicaragua/Clientes'; // ajusta si usas otro endpoint

export const getClientes = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener clientes:', error);
    return [];
  }
};

export const addCliente = async (cliente) => {
  try {
    //console.log(API_URL);

    const response = await axios.post(API_URL, cliente);
    return response.data;
  } catch (error) {
    //console.error('Error al guardar cliente 1', error);
    throw error;
  }
};

export const updateCliente = async (id, cliente) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, cliente);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar cliente', error);
    throw error;
  }
};

export const eliminarCliente  = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar cliente', error);
    throw error;
  }
};

export const  getNumeroNextCliente= async()  =>
{
    try{
    const response = await axios.get(`${API_URL}/NextNoCliente`);
    return response.data;    
    }
    catch(error)
    {
      console.error('Error al obtener el numero del siguiente cliente', error);
      throw error;
    }
}


